"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextBubbleBase = void 0;
const tslib_1 = require("tslib");
const consts_1 = require("../../consts");
const TextBubbleFullBase_1 = require("./TextBubbleFullBase");
const TextBubbleCSS_1 = require("./TextBubbleCSS");
const DialogueElement_1 = require("../../webComponents/DialogueElement");
class TextBubbleBase extends TextBubbleFullBase_1.TextBubbleFullBase {
    constructor(scene, imagesList, getDevicePixelRatio, stylesAlias, isMultiplayer, textBubbleController) {
        super(scene, imagesList, getDevicePixelRatio, textBubbleController);
        this.text = '';
        this.side = consts_1.SIDE.CENTER;
        this.characterName = '';
        this.cachedBoundsData = false;
        this._stylesAlias = stylesAlias;
        this._isMultiplayer = isMultiplayer;
    }
    init(text = ' ', side = consts_1.SIDE.CENTER, characterName = '') {
        var _a, _b, _c, _d, _e;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.text = text !== null && text !== void 0 ? text : ' ';
            this.side = side;
            this.characterName = characterName;
            const bubbleType = (_b = (_a = this.textBubbleController) === null || _a === void 0 ? void 0 : _a.currentType) !== null && _b !== void 0 ? _b : consts_1.STORY_STATE.Dialogue;
            const globalStyles = TextBubbleCSS_1.TextBubbleCSS.getDialogueCSSByAlias(this._stylesAlias);
            // const globalStyles = TextBubbleCSS.getDialogueCSSByAlias(GameUIStyle.Arcana);
            // const globalStyles2 = TextBubbleCSS.getDialogueCSSByAlias(GameUIStyle.Arcana);
            const realText = this.isRawText
                ? this.text
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                : this.text;
            const html = `
        <div class="container">
            <div class="extras"></div>
            <div class="dialogue">
                <div class="dialogue-heading">${characterName}</div>
                <div class="dialogue-body"><span>${realText}</span></div>
            </div>
        </div>
        `;
            this.dialogueElement = new DialogueElement_1.DialogueElement({
                template: html,
                styles: globalStyles,
            });
            this.dialogueElement.classList.toggle('side-left', side === consts_1.SIDE.LEFT);
            this.dialogueElement.classList.toggle('side-right', side === consts_1.SIDE.RIGHT);
            // TODO: move .is-multiplayer to the top domLayer
            this.dialogueElement.classList.toggle('is-multiplayer', this._isMultiplayer);
            const bubbleTypeKeySearch = Object.entries(consts_1.STORY_STATE).find(([_, value]) => value === bubbleType);
            const bubbleTypeKey = ((_d = (_c = bubbleTypeKeySearch === null || bubbleTypeKeySearch === void 0 ? void 0 : bubbleTypeKeySearch[0]) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : 'Dialogue').toLowerCase();
            this.dialogueElement.classList.toggle(`type-${bubbleTypeKey}`, true);
            (_e = this.gameplayScene.getGameplayRenderer()) === null || _e === void 0 ? void 0 : _e.domLayer.appendChild(this.dialogueElement);
            this.dialogueElement.classList.toggle('invisible-text', !this.isVisibleText);
        });
    }
    uninit() {
        var _a;
        if (!this.dialogueElement) {
            return;
        }
        try {
            (_a = this.gameplayScene.getGameplayRenderer()) === null || _a === void 0 ? void 0 : _a.domLayer.removeChild(this.dialogueElement);
        }
        catch (e) {
        }
        this.dialogueElement.cleanShadowRoot();
        super.uninit();
        // if(this.textfield) {
        //     this.textfield.uninit();
        // }
    }
    destroy() {
        this.uninit();
        super.destroy();
    }
    updateStylesAlias(stylesAlias) {
        this._stylesAlias = stylesAlias;
        if (!this.dialogueElement) {
            return;
        }
        const globalStyles = TextBubbleCSS_1.TextBubbleCSS.getDialogueCSSByAlias(this._stylesAlias);
        this.dialogueElement.styles = globalStyles;
    }
    /**
     * Use if need to calculate something in init before creating textfields
     */
    extraCalculationsBeforeTextfields() { }
    calcElementsBoundsData() {
        // this.cachedBoundsData = {
        //     x: 0,// (textfieldBoundsFinal.x/dPR),
        //     y: 0,//(textfieldBoundsFinal.y/dPR),
        //     width: 0,//widthAll,
        //     height: 0,//heightAll,
        //     fontSize: 0,//roundUpFontSize,
        //     fontStyle: 'Lato',// this.fontStyle,
        //     paddingLeft: 0,//paddingLeft,
        //     paddingRight: 0,//paddingRight,
        //     paddingTop: 0, //((this.textMarginVertical ?? 0)/dPR),
        //     paddingBottom: 0,// ((this.textMarginVertical ?? 0)/dPR),
        //     textAlign: 'center',// this.textAlign,
        //     textColor: 'red',// this.textColor,
        //     lineSpacing: 20,// (this.getLineSpacing() / dPR),
        //     fullElementBounds: {
        //         x: 0,//(this.parentContainerPosX + this.x)/ dPR,
        //         y: 0,//(this.parentContainerPosY + this.y)/ dPR,
        //         width: 0,//(this.borderInnerWidth ?? 0)/ dPR,
        //         height: 0,//(this.borderInnerHeight ?? 0) / dPR
        //     }
        // };
        var _a, _b;
        this.cachedBoundsData = (_b = (_a = this.dialogueElement) === null || _a === void 0 ? void 0 : _a.calculateBounds()) !== null && _b !== void 0 ? _b : false;
    }
    getElementBoundsData() {
        return this.cachedBoundsData || false;
    }
    updateText(text) {
        if (this.text === text) {
            return;
        }
        this.text = text;
        if (!this.dialogueElement) {
            return;
        }
        this.dialogueElement.mainText = text;
    }
}
exports.TextBubbleBase = TextBubbleBase;
